export default __webpack_public_path__ + "static/media/aircraft-body-desc.e0015443.png";